import CrossTabConfig from './CrossTabConfig';
export const removeBroadcastMessageHandler = fn => {
  const callingWorkerDetails = CrossTabConfig.get();
  const indexToRemove = callingWorkerDetails.broadcastMessageHandlers.indexOf(fn);
  if (indexToRemove >= 0) {
    callingWorkerDetails.broadcastMessageHandlers.splice(indexToRemove, 1);
  }
};
export const addBroadcastMessageHandler = fn => {
  const callingWorkerDetails = CrossTabConfig.get();
  callingWorkerDetails.broadcastMessageHandlers.push(fn);
  return () => {
    removeBroadcastMessageHandler(fn);
  };
};